export const setUserResultRate = async ({ commit }) => {
    commit('SET_USER_RESULT_RATE');
};
